<template>
    <div class="p-grid">
       <!-- Mensagem de acesso -->

       <div class="p-col-12" v-if="session.semAcesso === 1">
                    <div class="card" style="background-color: red; color: white; padding: 20px;">
                        Você possui parcelas em atraso. Verifique junto à central. Não fique desprotegido, regularize suas parcelas.
                    </div>
                </div>
                <div class="p-col-12" v-if="session.semAcesso === 2">
                    <div class="card" style="background-color: red; color: white; padding: 20px;">
                        Você possui parcelas em atraso. Verifique junto à central. Não fique desprotegido, regularize suas parcelas. Seu acesso está bloqueado temporariamente.
                    </div>
                </div>

        <div class="p-col-12" v-if="session.semAcesso !== 2">
            <div class="card">
                <SmartTable :entity-meta="meta">
                    <template #title>Proprietários</template>
                </SmartTable>
            </div>
        </div>
    </div>
</template>

<script>
import SmartTable from "../SmartTable";
import meta from "./entity-meta";
import { mapState } from "vuex";


export default {
    data: () => ({
        meta
    }),
    components: {
        SmartTable
    },
    computed: {
        ...mapState({
            session: state => state.session // Acessa o estado da sessão diretamente
        })
    },    
};
</script>

<style>
</style>